module.exports = __webpack_public_path__ + "static/img/logo.1f555135.png";